import { motion } from 'framer-motion';
import { CSSProperties, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  buttonStyles,
  buttonTextStyles,
  containerStyles,
  dotLeftBottom,
  dotLeftTop,
  dotRightTop,
  headerTextStyles,
  iconsContainerStyles,
  textStyles
} from '@/components/Discovery/Card/placeholders/styles.ts';
import LockShape from '@/components/common/svg/shapes/LockShape.tsx';
import GhostShape from '@/components/common/svg/shapes/GhostShape.tsx';
import Modal from '@/animations/Modal.tsx';
import PaywallPopup from '@/components/Popup/PaywallPopup/PaywallPopup.tsx';
import { PaywallTypes, ProductInvoicePlacements } from '@/enums/apiEnums.ts';
import { useProfileStore } from '@/store/useProfileStore.ts';

export const ProfileHiddenLock = () => {
  const { t } = useTranslation();
  const { premium, shadowProfile } = useProfileStore();

  const [payWallOpen, setPayWallOpen] = useState<boolean>(false);

  const closePayWall = () => setPayWallOpen(false);
  const openPayWall = () => setPayWallOpen(true);

  const enableIncognitoMode = async () => {
    if (premium.isExpired) {
      openPayWall();
      return;
    }

    await shadowProfile();
  };

  return (
    <div style={containerStyles}>
      <div
        style={{
          ...iconsContainerStyles,
          width: '94px',
          height: '94px'
        }}
      >
        <GhostShape
          width={100}
          height={100}
          fillColor="#505050"
          style={{
            marginTop: '0px',
            marginLeft: '-3px'
          }}
        />

        <div style={secondaryShapeBg}>
          <LockShape
            width={25}
            height={25}
            fillColor="#2f333d"
            strokeWidth={3}
          />
        </div>

        <div style={dotLeftBottom} />
        <div style={dotLeftTop} />
        <div style={dotRightTop} />
      </div>

      <h3 style={headerTextStyles}>
        {t('discovery.card.placeholder.hidden.header')}
      </h3>
      <p style={textStyles}>{t('discovery.card.placeholder.hidden.text')}</p>

      <motion.div
        whileTap={{ scale: 0.9 }}
        style={buttonStyles}
        onClick={enableIncognitoMode}
      >
        <span style={buttonTextStyles}>
          {t('discovery.card.placeholder.hidden.btn_label')}
        </span>
      </motion.div>

      <Modal
        fullScreen
        scrollable
        open={payWallOpen}
        handleClose={closePayWall}
      >
        <PaywallPopup
          handleClose={closePayWall}
          type={PaywallTypes.TYPE_SUBSCRIPTION}
          placement={
            ProductInvoicePlacements.MATCHMAKER_PROFILE_HIDDEN_LOCK_SCREEN
          }
        />
      </Modal>
    </div>
  );
};

const secondaryShapeBg: CSSProperties = {
  position: 'absolute',
  width: '30px',
  height: '30px',
  borderRadius: '18px',
  background: '#d9e0ec',
  bottom: '-5px',
  left: '33px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
};
